const MESSAGES = {
  "auth/invalid-credential": "Email o contraseña incorrectos.",
  "auth/wrong-password": "Email o contraseña incorrectos.",
  "auth/user-not-found": "Email o contraseña incorrectos.",
  "auth/invalid-email": "El email no es válido.",
  "auth/missing-email": "Ingresá tu email.",
  "auth/email-already-in-use": "Ya existe una cuenta con ese email.",
  "auth/weak-password": "La contraseña debe tener al menos 6 caracteres.",
  "auth/too-many-requests": "Demasiados intentos. Esperá unos minutos y volvé a intentar.",
  "auth/user-disabled": "Esta cuenta está deshabilitada.",
  "auth/network-request-failed": "Sin conexión. Revisá tu internet.",
  "permission-denied": "No tenés permiso para realizar esta acción.",
  unavailable: "El servicio no está disponible. Revisá tu conexión.",
  "storage/unauthorized": "No tenés permiso para acceder a este archivo.",
  "storage/object-not-found": "El archivo ya no existe.",
  "storage/canceled": "La subida fue cancelada.",
  "storage/quota-exceeded": "Se superó el espacio de almacenamiento disponible.",
  "storage/retry-limit-exceeded": "La conexión es inestable. Volvé a intentar.",
  "archivo/no-coincide": "El archivo descargado no coincide con el original. Volvé a intentar.",
};

// Log de diagnóstico para lecturas/escrituras de Firestore.
// Distingue "permiso denegado" (reglas o proyecto mal configurado) de "no encontrado" (el documento no existe).
export function logDataError(action, error) {
  const code = error?.code || "desconocido";
  if (code === "permission-denied" || code === "storage/unauthorized") {
    const rules = code === "permission-denied" ? "firestore.rules" : "storage.rules";
    console.error(
      `[OdontoSend] PERMISO DENEGADO al ${action}. Revisá ${rules} y que la configuración de .env apunte al proyecto correcto.`,
      error
    );
  } else if (code === "not-found" || code === "storage/object-not-found" || code === "storage/bucket-not-found") {
    console.warn(`[OdontoSend] NO ENCONTRADO al ${action}: el documento o la colección no existe.`, error);
  } else {
    console.error(`[OdontoSend] Error (${code}) al ${action}.`, error);
  }
}

export function logNotFound(action, detail) {
  console.warn(`[OdontoSend] NO ENCONTRADO al ${action}: ${detail}`);
}

// Errores de las Cloud Functions que ya traen un mensaje para el usuario (ver functions/servicioConexiones.js).
const FUNCTION_MESSAGE_CODES = ["invalid-argument", "failed-precondition", "not-found", "permission-denied", "resource-exhausted", "unauthenticated"];

export function errorMessage(error, fallback = "Ocurrió un error inesperado. Volvé a intentar.") {
  const code = error?.code || "";
  if (code.startsWith("functions/") && FUNCTION_MESSAGE_CODES.includes(code.slice(10)) && error.message) return error.message;
  return MESSAGES[code] || fallback;
}
